import axios from 'axios';
import authHeader from './auth-header';

const API_URL = import.meta.env.VITE_API_URL;

const getCustomers = () => axios.get(`${API_URL}/customers/`, { headers: authHeader() });
const createCustomer = (data) => axios.post(
  `${API_URL}/customers/`,
  data,
  { headers: authHeader() },
);

// PATCH et non PUT : le formulaire ne porte pas tous les champs de la fiche,
// et un PUT partiel effacerait en silence ceux qu'il ne renvoie pas.
const updateCustomer = (customerId, data) => axios.patch(
  `${API_URL}/customers/${customerId}/`,
  data,
  { headers: authHeader() },
);

// Côté API, ce DELETE ARCHIVE le membre : il pose `archived = True` et ne
// touche pas à ses prêts. Voir `src/customers/membership.py` dans le
// backend — `Lending.customer` est en CASCADE, une suppression réelle
// emporterait tout l'historique.
const deleteCustomer = (customerId) => axios.delete(
  `${API_URL}/customers/${customerId}/`,
  { headers: authHeader() },
);

const customersService = {
  getCustomers,
  createCustomer,
  updateCustomer,
  deleteCustomer,
};

export default customersService;
